import React from 'react';
import ReactDOM from 'react-dom';
import {Link } from 'react-router-dom';

class BottomMenu extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          currentLocation: props.LOCATION
      };
    }  

    render() { 
      let profile = (localStorage.getItem('userData')==null)?'/login':'/profile';
      let reorder = (localStorage.getItem('userData')==null)?'/login':'/reorder';

      let cartItemCount = 0;
      let cart = localStorage.getItem('cartData');
      let cartData = JSON.parse(cart);
      if(cart !== null && cart!=='{}')
      {
          Object.keys(cartData).forEach(function(key) {
              let itemCOUNT = cartData[key];
              cartItemCount = parseFloat(cartItemCount) + parseFloat(itemCOUNT);
          });    
      }

      let homeCSS = this.state.currentLocation=='/home'?' active':'';
      let listingCSS = this.state.currentLocation=='/categories'?' active':'';
      if(this.state.currentLocation.search('category')=='1')
        listingCSS = ' active';
      let cartCSS = this.state.currentLocation=='/cart'?' active':'';
      let reorderCSS = this.state.currentLocation=='/reorder'?' active':'';
      let profileCSS = this.state.currentLocation=='/profile'?' active':'';

      return (
        <div className="appBottomMenu"> 
          <Link to="/home" className={`item${homeCSS}`}>
            <div className="col">
              <ion-icon name="home-outline" role="img" className="md hydrated" aria-label="file tray full outline"></ion-icon>
              <strong>Home</strong> 
            </div>
          </Link> 
          <Link to="/categories" className={`item${listingCSS}`}>
            <div className="col">
              <ion-icon name="list" role="img" className="md hydrated" aria-label="calendar outline"></ion-icon>
              <strong>Categories</strong>
            </div>
          </Link>
          <Link to="/cart" className={`item${cartCSS}`}>
            <div className="col">
              <div className="action-button large">
                {cartItemCount!=0 && <span className="badge badge-danger">{cartItemCount}</span>}
                <ion-icon name="cart-outline" role="img" className="md hydrated" aria-label="add outline"></ion-icon>
              </div>
            </div>
          </Link> 
          <Link to={reorder} className={`item${reorderCSS}`}>
            <div className="col">
            <ion-icon name="heart-circle-outline" role="img" className="md hydrated" aria-label="document text outline"></ion-icon>
              <strong>Reorder</strong>
            </div>
          </Link>
          <Link to={profile} className={`item${profileCSS}`}>
            <div className="col">
            <ion-icon name="person-circle-outline" role="img" className="md hydrated" aria-label="people outline"></ion-icon>
              <strong>Profile</strong>
            </div>
          </Link>
        </div>
      );
    }
}
  
export default BottomMenu;


// WEBPACK FOOTER //
// ./src/components/BottomMenu.js